
import * as tools from '../../utils/tools';
import {helpers} from '../reportingHelpers';
import { ReportControlGroup } from './reportControlGroup';
import { ImageScalingTypes } from "../../utils/dvtypes";

export default {
    render: function(def, ctx, callback){
        let outPDF = ctx.rootContext.pdf;

        //This function handles the content and base64 data (so we don't duplicate logic) ... EK
        function applyImageToPDF(contentType, encodedImage){
            let imageType = contentType.split('/')[1];

            // Wrap jpg as jpeg since that is the native mime type...EK
            if (imageType === 'jpg') imageType = 'jpeg';
            // Validate that the content type returned is an image and an image that is either jpeg or png...EK
            if (['jpeg', 'png'].includes(imageType)){
                // Take the bytes returned and load into a temporary image for the PDF...EK
                let image = document.createElement('img');
                image.onload = function() {
                    let pad = (def.Style.padding || 0) + ((def.Style.borderWidth|| 0) / 2),
                        x = helpers.getRenderLeft(def, ctx) + pad,
                        y = helpers.getRenderTop(def, ctx) + pad,
                        w = def.Width - (pad * 2),
                        h = def.Height - (pad * 2),
                        setWidth = w,
                        setHeight = h,
                        nw = image.naturalWidth,
                        nh = image.naturalHeight,
                        ratioW = w / nw,
                        ratioH = h / nh;

                    // Apply a 0px invisible clipping path for the image
                    outPDF.internal.write('q'); // saves the current state before clipping
                    if (style.background != null){
                        outPDF.setDrawColor(style.background.r, style.background.g, style.background.b);
                    }
                    else {
                        outPDF.setDrawColor(255, 255, 255);
                    }
                    outPDF.setLineWidth(0);
                    outPDF.rect(x, y, w, h, null);
                    outPDF.clip();

                    switch (def.Style.scaling) {
                        case ImageScalingTypes.Clip:
                            // Fills the container, maintaining aspect ratio and clipping any overflow
                            if (ratioW > ratioH) {
                                // The width is the "base" axis (the minimum axis the image can fit in)
                                setHeight = Math.floor(ratioW * nh);
                            }
                            else {
                                // The height is the "base" axis
                                setWidth = Math.floor(ratioH * nw);
                            }
                            break;

                        case ImageScalingTypes.Stretch:
                            // Fills the container ignoring aspect ratio
                            break;

                        case ImageScalingTypes.Actual:
                            // Uses the images natural width and height
                            setHeight = nh;
                            setWidth = nw;
                            break;

                        case ImageScalingTypes.Fit:
                        default:
                            // Fills the smallest axis, maintaining aspect ratio (our original default fit)
                            if (ratioW < ratioH) {
                                // The width is the "base" axis (the maximum axis the image can fit in)
                                setHeight = Math.floor(ratioW * nh);
                            }
                            else {
                                // The height is the "base" axis
                                setWidth = Math.floor(ratioH * nw);
                            }
                    }

                    // Calculate image offsets so that the center of the image is equal to the center of the control
                    x += (w - setWidth) / 2;
                    y += (h - setHeight) / 2;

                    // Re-encode the image with the new size to decrease file size
                    let canvas = document.createElement('canvas');
                    canvas.width = setWidth;
                    canvas.height = setHeight;
                    canvas.getContext('2d').drawImage(image, 0, 0, setWidth, setHeight);
                    let imageData = canvas.toDataURL(String(imageType).toLowerCase() === 'png' ? 'image/png' : 'image/jpeg', 1);

                    outPDF.addImage(imageData, imageType, x, y, setWidth, setHeight);
                    outPDF.internal.write('Q'); // restores the state to where there was no clipping
                    (new ReportControlGroup()).render(def, ctx, callback);
                    image = null;
                };

                image.src = `data:image/${imageType};base64,${encodedImage}`;
            }
            else {
                // The content type that was returned from the url is not supported...EK
                console.warn(`Cannot apply an image to the PDF of type: ${imageType}`);
                callback();
            }
        }

        //Handle the styling aspects of the image control...EK
        var style = def.Style;
        if (style.borderWidth != null && style.borderWidth > 0){
            outPDF.setLineWidth(style.borderWidth);
            outPDF.setDrawColor(style.borderColor.r, style.borderColor.g, style.borderColor.b);

            if (style.background != null){
                outPDF.setFillColor(style.background.r, style.background.g, style.background.b, null);
            }
            else {
                outPDF.setFillColor(255, 255, 255, null);          //Default a border, but no background to white...EK
            }

            outPDF.roundedRect(helpers.getRenderLeft(def, ctx), helpers.getRenderTop(def, ctx), def.Width, def.Height, style.borderRadius, style.borderRadius, 'B');
        }
        else if (style.background != null){
            outPDF.setFillColor(style.background.r, style.background.g, style.background.b, null);
            outPDF.rect(helpers.getRenderLeft(def, ctx), helpers.getRenderTop(def, ctx), def.Width, def.Height, 'F');
        }

        if (def.runTime.contentType && def.runTime.encodedImage) {
            applyImageToPDF(def.runTime.contentType, def.runTime.encodedImage);
        }
        else {
            //This has no image source, render as empty panel.
            callback();
        }
    },
    preRender: function(def, ctx, callback) {
        //This control doesn't change size, no pre-render is needed at this time, just callback...EK
        if (def.runTime == null) {
            def.runTime = {top: def.Top};
        }
        else {
            def.runTime.top = def.Top;      // Reset the top in case of growth layout changes...EK
        }

        if (def.Src.Expr != null) {
            def.runTime.Url = app.dv.tools.evaluateExpression(def.Src.Expr, ctx.mvc);
        }
        else {
            if (def.Src.PropertyID != null && typeof def.Src.PropertyID === 'object') {
                def.runTime.PropertyID = def.Src.PropertyID;
            }
            else if (def.Src.Url != null && def.Src.Url != '') {
                def.runTime.Url = def.Src.Url;
            }
        }

        function handleControlGroup() {
            (new ReportControlGroup()).preRender(def, ctx, callback);
        }

        // Check to see if we have a URL defined, if so download it through our svc proxy...EK
        //      NOTE: This proxy is required due to security limitations of capturing image data from a cross domain web request...EK
        if (def.runTime.Url != null) {
            if (def.runTime.Url.toLowerCase().startsWith('data:image')) {
                let parts = def.runTime.Url.substring(5).split(',');
                def.runTime.contentType = parts[0].substring(0, parts[0].indexOf(';'));
                parts.splice(0, 1);
                def.runTime.encodedImage = parts.join(',');
                handleControlGroup();
            }
            else if (def.runTime.cacheRes == null) {
                // We don't have this image cached.. we need to go get it...EK
                app.dv.services.call(
                    app.dv.services.endpoints.proxyWebResource,
                    {url: def.runTime.Url, encoding: 'base64'},
                    (webRes, err) => {
                        if (err != null) {
                            console.warn(`Error while trying to pull image data from ${def.runTime.Url}: `, err.message || err);
                            callback();
                        }
                        else {
                            def.runTime.cacheRes = webRes;
                            def.runTime.contentType = webRes.contentType;
                            def.runTime.encodedImage = webRes.responseData;
                            handleControlGroup();
                        }
                    }
                );
            }
            else {
                //We have already made this call for a static url.. just use the cached response...EK
                handleControlGroup();
            }
        }
        else if (def.runTime.PropertyID != null) {
            //The image is an attachment, pull for this record / property...EK
            if (ctx.dataContext != null) {
                //Get the dynamicValue for the property id specified, and then download the value if one exists...EK
                let attachGV = ctx.dataContext.gridValues.getVal(def.runTime.PropertyID),
                    attachVal = attachGV.dynamicValue;
                if (attachGV != null && attachVal._State === app.dv.types.EntityStates.Unmodified) {
                    let attachExt = '';
                    if (attachVal.ValueMetadata !== "") {
                        // The following converts the file name to a content type (if possible) ... (i.e myImage.png => png) ... EK
                        // use a parse that supports NaN as some metadata may contain it; this would error in regular JSON.parse()
                        let attachNameKVP = JSON.parseMore(attachVal.ValueMetadata).find(kvp => kvp.Key === 'FileName');
                        if (attachNameKVP != null && attachNameKVP.Value != null && typeof attachNameKVP.Value === 'string') {
                            attachExt = attachNameKVP.Value.split('.');

                            if (attachExt.length === 1) {
                                //This occurs because the document was cleared out, or has no extension, just callback...EK
                                handleControlGroup();
                                return;
                            }

                            attachExt = attachExt[attachExt.length - 1];        // Captures the actual extension (last extension if there are more than one) ... EK
                        }
                    }

                    //Download the attachment...EK
                    app.dv.services.call(
                        app.dv.services.endpoints.getByID,
                        {ForType: attachVal.DataType, TypeValueID: attachVal.TypeValueID},
                        (valRes, err) => {
                            if (err != null) {
                                console.log(`Error while retrieving attached image: ${err}`);
                                callback();
                            }
                            //else: process the data that came back from the server...EK

                            def.runTime.contentType = `image/${attachExt}`;
                            def.runTime.encodedImage = tools.arrayBufferToBase64(valRes.Value.data);
                            handleControlGroup();
                        }
                    );
                }
                else if (attachGV != null && (
                    attachVal._State === app.dv.types.EntityStates.Modified || attachVal._State === app.dv.types.EntityStates.NewObject)) {
                    // if the image is modified, we should have the data in the grid value.
                    if (attachVal.Value != null) {
                        let attachExt = '';
                        if (attachVal.ValueMetadata !== "") {
                            // The following converts the file name to a content type (if possible) ... (i.e myImage.png => png) ... EK
                            // use a parse that supports NaN as some metadata may contain it; this would error in regular JSON.parse()
                            let attachNameKVP = JSON.parseMore(attachVal.ValueMetadata).find(kvp => kvp.Key === 'FileName');
                            if (attachNameKVP != null && attachNameKVP.Value != null && typeof attachNameKVP.Value === 'string') {
                                attachExt = attachNameKVP.Value.split('.');

                                if (attachExt.length === 1) {
                                    //This occurs because the document was cleared out, or has no extension, just callback...EK
                                    handleControlGroup();
                                    return;
                                }

                                attachExt = attachExt[attachExt.length - 1];        // Captures the actual extension (last extension if there are more than one) ... EK
                            }
                        }

                        def.runTime.contentType = `image/${attachExt}`;
                        def.runTime.encodedImage = attachVal.Value;
                        handleControlGroup();
                    }
                    else {
                        // modified image, but no value - need to continue as if there was no image.
                        handleControlGroup();
                    }
                }
                else {
                    //We either have an invalid value, or the value is unsaved, or the value is empty, just callback...EK
                    handleControlGroup();
                }
            }
            else {
                handleControlGroup();
            }
        }
        else {
            //Unknown/unhandled source type...EK
            //This has no image source, render as empty panel.
            callback();
        }

    }
};
